import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { WizardService } from 'src/app/services/wizard/wizard.service';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent implements OnInit {
  @Input() previousStepRoute: string = "";
  @Input() previousStepNumber: number = 0;
  @Input() currentStepName: string = "";
  @Input() totalSteps: number = 0;
  buttonText: string = "";

  constructor(
    private analyticsService: AnalyticsService,
    private confSvc: ConfigService,
    private wizardService: WizardService,
    private router: Router) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();

    this.buttonText = this.confSvc.getString("backButtonText");
  }

  backBtnClickEvent(): void {
    this.analyticsService.logBackBtnClick(this.currentStepName);

    this.wizardService.getStepRoutingQueryString().subscribe((queryString: string) => {
      this.router.navigateByUrl(`${this.previousStepRoute}${queryString}`);
    });
  }
}
